import React, { useMemo } from "react";
import classes from "./index.module.scss";
import { message, Select, Table } from "antd";
import { ColumnFilterItem, ColumnProps } from "antd/lib/table/interface";
import {
    SignStatus,
    StuSignIn,
    StuSignInMap,
    StuSignInStatus,
    updateStuSignStatus
} from "service/signIn";
import moment from "moment";
import _ from "underscore";
import { errorMessage, toNumber } from "service/service";
import classNames from "classnames";
import {
    SignType,
    updateStuOnLineSignStatus
} from "../../../../../service/signIn";

interface SignInTableProps {
    signInId: number;
    signStatus: SignStatus;
    data: StuSignIn[];
    onChange: () => void;
    type?: SignType;
}

export default function SignInTable({
    signInId,
    signStatus,
    data,
    onChange,
    type
}: SignInTableProps) {
    // 过滤签到状态
    const filters: ColumnFilterItem[] = useMemo(() => {
        return _.sortBy(
            _.uniq(_.pluck(data, "signStatus")).map(value => ({
                text: StuSignInMap[value],
                value: String(value)
            })),
            "value"
        );
    }, [data]);

    const columns: ColumnProps<StuSignIn>[] = [
        {
            title: "班级",
            dataIndex: "className",
            align: "center",
            width: 200
        },
        {
            title: "学生信息",
            dataIndex: "name",
            render: renderStudent
        },
        {
            title: "签到状态",
            dataIndex: "signStatus",
            render: renderStatus,
            align: "center",
            width: 150,
            filters: signStatus === SignStatus.Done ? filters : undefined,
            onFilter: (value, record) => toNumber(value) === record.signStatus
        },
        {
            title: "签到时间",
            dataIndex: "signInTime",
            align: "center",
            width: 200,
            render: (text: string) =>
                text ? moment(text).format("MM-DD HH:mm:ss") : "",
            sorter:
                signStatus === SignStatus.Done
                    ? (itemA, itemB) =>
                          itemA.signInTime > itemB.signInTime ? 1 : -1
                    : undefined,
            sortDirections: ["ascend", "descend"]
        }
    ];

    // 学生信息
    function renderStudent(text: string, item: StuSignIn) {
        return (
            <div className={classes.student}>
                {text}
                <span className={classes.stuNo}>{item.studentno}</span>
            </div>
        );
    }

    // 修改学生签到状态
    async function handleStatusChange(
        item: StuSignIn,
        signStatus: StuSignInStatus
    ) {
        try {
            if (type === SignType.Live) {
                await updateStuOnLineSignStatus({
                    signInId,
                    studentno: item.studentno,
                    signStatus
                });
            } else {
                await updateStuSignStatus({
                    signInId,
                    studentno: item.studentno,
                    signStatus
                });
            }
            onChange();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    // 签到状态
    function renderStatus(text: StuSignInStatus, item: StuSignIn) {
        if (signStatus !== SignStatus.Done)
            return (
                <span className={classes[`status${item.signStatus}`]}>
                    {StuSignInMap[text]}
                </span>
            );

        return (
            <Select
                getPopupContainer={getContainer}
                className={classNames(
                    classes.select,
                    classes[`status${item.signStatus}`]
                )}
                defaultValue={text}
                onChange={(newStatus: number) =>
                    handleStatusChange(item, newStatus)
                }>
                {_.map(StuSignInMap, (label, value) => (
                    <Select.Option key={value} value={toNumber(value)}>
                        {label}
                    </Select.Option>
                ))}
            </Select>
        );
    }

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    return (
        <div className={classes.root}>
            <Table
                getPopupContainer={getContainer}
                columns={columns}
                dataSource={data}
                rowKey="studentno"
                pagination={false}
                scroll={{ y: "calc(100vh - 355px)" }}
            />
        </div>
    );
}
